import { useTranslation } from 'react-i18next';
import type { SplitStatus } from '@/shared/types/api/splits';
import { Chip } from '@/shared/ui/chips/Chip';

type Props = {
  status: SplitStatus;
  className?: string;
};

const STATUS_STYLES: Record<SplitStatus, string> = {
  DRAFT: 'bg-slate-100 text-slate-700 border-slate-200',
  IN_PROGRESS: 'bg-sky-100 text-sky-800 border-sky-200',
  DELIVERED: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export const SplitStatusChip = ({ status, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip tone={STATUS_STYLES[status]} className={className}>
      {t(`splits.status.${status}`)}
    </Chip>
  );
};
